import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';

import { createAppTheme } from '@/theme';

import {
  errorPageButtonSx,
  errorPageIconSx,
  errorPagePaperSx,
  errorPageWrapperSx,
} from './ErrorPage.styles';

const loadDarkMode = (): boolean => {
  try {
    const saved = localStorage.getItem('user.darkMode');
    return saved ? JSON.parse(saved) : true;
  } catch {
    return true;
  }
};

export const ErrorPage = () => {
  const handleReload = () => {
    globalThis.location.reload();
  };

  const theme = createAppTheme(loadDarkMode());

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={errorPageWrapperSx}>
        <Paper elevation={3} sx={errorPagePaperSx}>
          <ErrorOutlineIcon sx={errorPageIconSx} />
          <Typography variant="h5" fontWeight="bold">
            Something went wrong
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Unable to load application data. Please try again.
          </Typography>
          <Button
            variant="contained"
            onClick={handleReload}
            sx={errorPageButtonSx}
          >
            Reload Page
          </Button>
        </Paper>
      </Box>
    </ThemeProvider>
  );
};
